module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('div', {
    staticClass: "my-4 display-1"
  }, [_vm._v("Podesite novu lozinku")]), _vm._v(" "), _c('v-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.resetPassword($event)
      }
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "lozinka",
      "required": "",
      "autocomplete": "new-password",
      "append-icon": _vm.showPassword ? 'visibility' : 'visibility_off',
      "type": _vm.showPassword ? 'text' : 'password'
    },
    on: {
      "click": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "append", undefined, $event.key, undefined)) { return null; }
        return (function () { return (_vm.showPassword = !_vm.showPassword); })($event)
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "potvrda lozinke",
      "required": "",
      "autocomplete": "new-password",
      "append-icon": _vm.showPassword ? 'visibility' : 'visibility_off',
      "type": _vm.showPassword ? 'text' : 'password'
    },
    on: {
      "click": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "append", undefined, $event.key, undefined)) { return null; }
        return (function () { return (_vm.showPassword = !_vm.showPassword); })($event)
      }
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "large": "",
      "block": "",
      "type": "submit",
      "loading": _vm.loading
    }
  }, [_vm._v("Sačuvaj")]), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "large": "",
      "block": "",
      "to": "/login"
    }
  }, [_vm._v("login")]), _vm._v(" "), (_vm.info) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "info"
    },
    domProps: {
      "textContent": _vm._s(_vm.info)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    },
    domProps: {
      "textContent": _vm._s(_vm.error)
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}